
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq-contact",
      function () {
        return require("private-next-pages/faq-contact.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faq-contact"])
      });
    }
  